import { render, staticRenderFns } from "./AdminTireBrands.vue?vue&type=template&id=13d87cd3&scoped=true"
import script from "./AdminTireBrands.vue?vue&type=script&lang=js"
export * from "./AdminTireBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d87cd3",
  null
  
)

export default component.exports